module.exports = __webpack_public_path__ + "static/media/EI_Caratula3.bf283115.png";